var React = require('react');

function Flower2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M134.076 84.984C142.364 92.81 151.28 100 158.94 108.46c14.675 15.665 26.512 32.926 31.727 54.018 3.582 14.166-3.642 22.416-18.53 21.575-15.52-.837-29.813-7.044-43.162-14.203-6.99-3.42-13.353-7.79-20.667-12.153.964 1.885 1.606 3.142 1.931 4.401 7.072 15.087 14.46 29.857 16.795 46.87.326 1.26.337 2.836.346 4.097.748 16.393-9.643 24.666-25.505 20.363-11.42-3.074-21.279-9.31-29.884-17.135-27.08-23.776-49.754-51.053-62.344-85.338C2.541 111.138-1.72 90.67.667 69.84 4.86 35.752 27.17 11.312 60.994 3.506c31.61-7.476 62.044-2.329 91.888 9.13 20.954 8.051 40.027 18.64 55.028 35.562 4.15 4.701 7.986 10.035 10.56 15.694 6.748 14.143.51 27.432-14.67 30.062-8.855 1.64-18.675 1.077-27.55-.437-13.948-2.11-27.275-6.115-41.228-9.17.002.315-.63.32-.946.637z"}));
}

Flower2.defaultProps = {"viewBox":"0 0 222 235"};

module.exports = Flower2;

Flower2.default = Flower2;
